export const urls = {
    dashboard: "/dashboard",
    users: "/users",
    devices: "/devices",
    trapAlarms: "/trap-alarms",
    purchases: "/purchases",
    packages: "/packages",
    codes: "/codes",
    bulkSMS: "/bulk-sms",
    firmware: "/firmware",
};
